import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { MeshPanel } from "@/features/mesh/components/mesh-panel";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@fleet/ui";

function MeshPage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Mesh`)}
      description={t(
        msg`Manage your mesh VPN: enroll devices, watch node liveness, download WireGuard configs and track bandwidth-contribution credits.`,
      )}
    >
      <PageContainer maxWidth="3xl">
        <MeshPanel />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const meshRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/mesh",
  component: MeshPage,
});
